import { Types } from "../actions/AutonomousMaintenanceDetailActions";

const initialState = {
    taskDetailById: null,
    sameLevelListById: null,
    breakdownRootCause: null,
    breakdownReasonGroupList: null,
    autonomousMaintenanceSave: null,
    autonomousMaintenanceClose: null,
    breakdownEffectList: null,
    technicianListByPoolId: null,
    autonomousMaintenanceAssign: null,
    autonomousMaintenance: null,
    setAutonomousMaintenanceCloaseComplete: null,
    autonomousMaintenancePause: null,
    autonomousMaintenanceUpdateTask: null,
    AddTechnician: null,
    breakdownReasonPlaceByGroupId: null,
    BreakdownReasonDetail: null,
    autonomousFiles: null,
    maintenancePauseReason: null,
    setTaskHistoryById: null,
    deleteTask: null,
    error: null,
};

export const AutonomousMaintenanceDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_AM_TASKS_DETAIL_BY_ID:
            return {
                ...state,
                taskDetailById: action.payload.resultObject,
            };
        case Types.SET_SAME_LEVEL_LIST_BY_ID:
            return {
                ...state,
                sameLevelListById: action.payload.resultObject,
            };
        case Types.SET_BREAK_DOWN_ROOT_CAUSE:
            return {
                ...state,
                breakdownRootCause: action.payload.resultObject,
            };

        case Types.SET_BREAK_DOWN_REASON_GROUP_LIST:
            return {
                ...state,
                breakdownReasonGroupList: action.payload.resultObject,
            };

        case Types.SET_BREAK_DOWN_Effect_LIST:
            return {
                ...state,
                breakdownEffectList: action.payload.resultObject,
            };
        case Types.SET_TECHNICAL_LIST_BY_POOL_ID:
            return {
                ...state,
                technicianListByPoolId: action.payload.resultObject,
            };

        case Types.SET_AUTONOMOUS_MAINTENANCE_ASSIGN_TASK:
            return {
                ...state,
                autonomousMaintenanceAssign: action.payload,
            };
        case Types.SET_AUTONOMOUS_MAINTENANCE_PLAY_START:
            return {
                ...state,
                autonomousMaintenance: action.payload,
            };
        case Types.SET_AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE:
            return {
                ...state,
                setAutonomousMaintenanceCloaseComplete: action.payload,
            };

        case Types.SET_AUTONOMOUS_MAINTENANCE_PAUSE:
            return {
                ...state,
                autonomousMaintenancePause: action.payload,
            };

        case Types.SET_AUTONOMOUS_MAINTENANCE_SAVE:
            return {
                ...state,
                autonomousMaintenanceSave: action.payload,
            };

        case Types.SET_AUTONOMOUS_MAINTENANCE_UPDATE_TASK:
            return {
                ...state,
                autonomousMaintenanceUpdateTask: action.payload,
            };

        case Types.SET_ADD_TECHNICIANS:
            return {
                ...state,
                AddTechnician: action.payload,
            };
        case Types.SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST:
            return {
                ...state,
                breakdownReasonPlaceByGroupId: action.payload,
            };
        case Types.SET_BREAK_DOWN_REASON_DETAIL:
            return {
                ...state,
                BreakdownReasonDetail: action.payload,
            };
        case Types.SET_AUTONOMOUS_FILES:
            return {
                ...state,
                autonomousFiles: action.payload,
            };

        case Types.SET_MAINTENANCE_PAUSE_REASON:
            return {
                ...state,
                maintenancePauseReason: action.payload,
            };

        case Types.SET_GET_TRACK_HISTORY_BY_ID:
            return {
                ...state,
                setTaskHistoryById: action.payload,
            };

        case Types.SET_DELEET_TASK:
            return {
                ...state,
                deleteTask: action.payload,
            };

        case Types.SET_PLAN_MAINTENANCE_PLAY_CLOSE:
            return {
                ...state,
                autonomousMaintenanceClose: action.payload,
            };

        case Types.SHOW_SNACK_MESSAGE_FOR_AUTONOMOUS_DETAIL:
            return {
                ...state,
                error: action.payload,
            };

        case Types.AUTONOMOUS_DETAIL_INITIAL_STATE_NULL:
            return {
                taskDetailById: null,
                sameLevelListById: null,
                breakdownRootCause: null,
                breakdownReasonGroupList: null,
                autonomousMaintenanceSave: null,
                autonomousMaintenanceClose: null,
                breakdownEffectList: null,
                technicianListByPoolId: null,
                autonomousMaintenanceAssign: null,
                autonomousMaintenance: null,
                setAutonomousMaintenanceCloaseComplete: null,
                autonomousMaintenancePause: null,
                autonomousMaintenanceUpdateTask: null,
                AddTechnician: null,
                breakdownReasonPlaceByGroupId: null,
                BreakdownReasonDetail: null,
                orderFiles: null,
                maintenancePauseReason: null,
                setTaskHistoryById: null,
                deleteTask: null,
                error: null,
            };

        default:
            return state;
    }
};
